// Modules
import cn from 'classnames'

// Types
import type { TAnchorProps } from './Anchor.type'

// Styles
import styles from './styles.module.scss'

// Constants
import { ANCHOR_DEFAULT_PROPS } from './Anchor.constant'

const Anchor = (props: TAnchorProps) => {
  const {
    children,
    className,
    disabled,
    size = ANCHOR_DEFAULT_PROPS.size,
    ...restProps
  } = props
  const tabIndex = disabled ? -1 : undefined

  const anchorCN = cn(className, styles.legion_anchor, styles[size!], {
    [styles.disabled]: disabled
  })

  return (
    <a
      className={anchorCN}
      aria-disabled={disabled}
      tabIndex={tabIndex}
      {...restProps}
    >
      {children}
    </a>
  )
}

export default Anchor;
